import { values } from 'ramda'

import type { SchoolType, SurveyListParams, SurveyListResult } from 'app/common/types/surveys'

import type { Request } from '../../index'
import { convertSurvey, SurveyDto } from './common'

export type SurveyListParamsDto = {
  archived?: boolean
  limit: number
  offset: number
  q?: string
  city_id?: Array<number>
  district_id?: Array<number>
  school_type?: Exclude<SchoolType, ''> | Array<Exclude<SchoolType, ''>>
  school_id?: Array<number>
  from?: string
  to?: string
}

export type SurveyListResultDto = {
  result: 'success'
  count: number
  surveys: Record<string, SurveyDto>
}

const convertIds = (ids: Array<string>) =>
  ids.length ? ids.map((v) => parseInt(v, 10)) : undefined

export const apiDateFormat = 'YYYY-MM-DD' as const

export const convertParams = (params: SurveyListParams): [SurveyListParamsDto, void] => {
  const { from, to } = params
  const fromDate = from ? from.getString(apiDateFormat) : undefined
  const toDate = to ? to.getString(apiDateFormat) : undefined

  return [
    {
      archived: params.archived || false,
      limit: params.limit,
      offset: params.offset,
      q: params.q || undefined,
      city_id: convertIds(params.cityIds),
      district_id: convertIds(params.districtIds),
      school_type: params.schoolTypes.length === 1 ? params.schoolTypes[0] : params.schoolTypes.length ? params.schoolTypes : undefined,
      school_id: convertIds(params.schoolIds),
      from: fromDate,
      to: toDate,
    },
    undefined,
  ]
}

export const convertResult = (data: SurveyListResultDto): SurveyListResult => ({
  items: values(data.surveys || {}).map(convertSurvey),
  total: data.count || 0,
})

export const GET_SURVEYS: Request<SurveyListParams, SurveyListResult, void> = [
  'food/surveys',
  'get',
  ['data'],
]
